export default __webpack_public_path__ + "static/media/leetcode-icon.a8a1b619.svg";